import { usePwaUpdate } from './PwaUpdateProvider';

export default usePwaUpdate;
